'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var isAdminInit = exports.isAdminInit = undefined;

exports.isAdminInit = isAdminInit = function isAdminInit(c) {
    var t = this,
        appManager = c.appManager,
        requestManager = c.requestManager,
        apiPath = appManager.getApiPath();

    return {
        baseUrl: appManager.getPath() + '/api/me/authorization/ALL',
        success: function success(r) {
            appManager.isAdmin = r;
            requestManager.ok(this);
        }
    };
};
//# sourceMappingURL=isAdminInit.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/init/isAdminInit.js
 ** module id = 123
 ** module chunks = 0 1
 **/